













































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storePersetujuanRanap } from "@/store/modules/PersetujuanRanapStore";
import PersetujuanRanapSvc from "@/services/PersetujuanRanap";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPersetujuanRanap extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isEditing = false;
  modalTtd = false;
  signRole = "";
  deleting = false;
  saving = false;
  formValid = false;

  hubunganOptions = [
    "Diri sendiri",
    "Suami",
    "Istri",
    "Anak",
    "Ayah",
    "Ibu",
    "Saudara kandung",
    "Lainnya"
  ];

  penjaminanOptions = [
    "BPJS PBI (APBN/APBD)",
    "BPJS Non PBI",
    "BPJS Mandiri",
    "Umum (Biaya Sendiri)",
    "Jamkesda/Jamkesos",
    "Jasa Raharja",
    "Asuransi Lainnya"
  ];

  kelasOptions = ["Kelas 1", "Kelas 2", "Kelas 3", "VIP", "VVIP"];
  kelasHakOptions = ["Kelas 1", "Kelas 2", "Kelas 3"];

  form: any = this.getEmptyForm();

  mounted() {
    storePersetujuanRanap.getByRegister(this.register);
  }

  getEmptyForm() {
    return {
      pj_nama: "",
      pj_jenis_kelamin: "",
      pj_tgl_lahir: "",
      pj_no_identitas: "",
      pj_hubungan: "",
      pj_hubungan_lainnya: "",
      pasien_no_hp: "",
      jenis_penjaminan: "",
      penjaminan_keterangan: "",
      kelas_dipilih: "",
      bangsal: "",
      kelas_hak: "",
      catatan: "",
      tempat_tanda_tangan: "Bantul"
    };
  }

  formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  formatDateTime(date) {
    return getHumanDateTime(date);
  }

  get stateuser() {
    return userModule.user;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get statePersetujuan() {
    return storePersetujuanRanap.persetujuan;
  }

  get canMakePersetujuan() {
    if (this.readOnly) return false;
    return true;
  }

  get canEdit() {
    if (this.readOnly) return false;
    if (!this.statePersetujuan) return false;
    return !(this.statePersetujuan.signed_penyetuju && this.statePersetujuan.signed_petugas);
  }

  get canSignPenyetuju() {
    if (this.readOnly) return false;
    return this.statePersetujuan && !this.statePersetujuan.signed_penyetuju;
  }

  get canSignPetugas() {
    if (this.readOnly) return false;
    return this.statePersetujuan && !this.statePersetujuan.signed_petugas;
  }

  get showPenjaminanKeterangan() {
    return this.form.jenis_penjaminan === "Jamkesda/Jamkesos" ||
      this.form.jenis_penjaminan === "Asuransi Lainnya";
  }

  onHubunganChange(val: string) {
    if (val === "Diri sendiri" && this.statePasien) {
      this.form.pj_nama = this.statePasien.nama || "";
      this.form.pj_tgl_lahir = this.statePasien.tgl_lahir || "";
      this.form.pj_jenis_kelamin = this.statePasien.jk === "Laki-laki" ? "L" : "P";
    }
    if (val !== "Lainnya") {
      this.form.pj_hubungan_lainnya = "";
    }
  }

  onDigitOnlyKeypress(e: KeyboardEvent) {
    if (e.key && e.key.length === 1 && !/\d/.test(e.key)) {
      e.preventDefault();
    }
  }

  onDigitOnlyPaste(e: ClipboardEvent) {
    const data = e.clipboardData ? e.clipboardData.getData("text") : "";
    if (data && /\D/.test(data)) {
      e.preventDefault();
      const cleaned = data.replace(/\D/g, "");
      if (cleaned) {
        document.execCommand("insertText", false, cleaned);
      }
    }
  }

  startEdit() {
    const c = this.statePersetujuan;
    this.form = {
      pj_nama: c.pj_nama || "",
      pj_jenis_kelamin: c.pj_jenis_kelamin || "",
      pj_tgl_lahir: c.pj_tgl_lahir || "",
      pj_no_identitas: c.pj_no_identitas || "",
      pj_hubungan: c.pj_hubungan || "",
      pj_hubungan_lainnya: c.pj_hubungan_lainnya || "",
      pasien_no_hp: c.pasien_no_hp || "",
      jenis_penjaminan: c.jenis_penjaminan || "",
      penjaminan_keterangan: c.penjaminan_keterangan || "",
      kelas_dipilih: c.kelas_dipilih || "",
      bangsal: c.bangsal || "",
      kelas_hak: c.kelas_hak || "",
      catatan: c.catatan || "",
      tempat_tanda_tangan: c.tempat_tanda_tangan || "Bantul"
    };
    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    if (!(this.$refs.formPersetujuan as any).validate()) return;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        pj_hubungan_lainnya: this.form.pj_hubungan === "Lainnya"
          ? this.form.pj_hubungan_lainnya
          : null,
        penjaminan_keterangan: this.showPenjaminanKeterangan
          ? this.form.penjaminan_keterangan
          : null
      };

      let resp;
      if (this.statePersetujuan && this.isEditing) {
        resp = await PersetujuanRanapSvc.update(this.statePersetujuan.id, payload);
      } else {
        resp = await PersetujuanRanapSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan Rawat Inap berhasil disimpan");
        this.isEditing = false;
        this.form = this.getEmptyForm();
        storePersetujuanRanap.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signFn =
      this.signRole === "penyetuju"
        ? PersetujuanRanapSvc.signPenyetuju
        : PersetujuanRanapSvc.signPetugas;

    const resp = await signFn(this.statePersetujuan.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      const label = this.signRole === "penyetuju" ? "Penyetuju" : "Petugas Admisi";
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
      appModule.addMsgTtd("");
      storePersetujuanRanap.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf() {
    PersetujuanRanapSvc.print(this.statePersetujuan.id);
  }

  async remove() {
    const q = confirm("Anda yakin akan menghapus Persetujuan Rawat Inap ini?");

    if (q && !this.deleting) {
      this.deleting = true;

      try {
        const resp = await PersetujuanRanapSvc.destroy(this.statePersetujuan.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storePersetujuanRanap.getByRegister(this.register);
        }
      } finally {
        this.deleting = false;
      }
    }
  }
}
